import moment from 'proxies/dayjs';

export const DateRangeConfig = {
    "THIS_WEEK": ()=>{
            var start = moment().subtract(0, 'days').startOf('day').valueOf();
            var end = moment().add(6, 'days').startOf('day').valueOf();
            return [start,end];
    },
    "TODAY": ()=>{
        var start = moment().startOf('day').valueOf();
        var end = moment().endOf('day').valueOf();
        return [start,end];
    },
    "TOMMOROW": ()=>{
        var start = moment().add(1,'days').startOf('day').valueOf();
        var end = moment().add(1, 'days').endOf('day').valueOf();
        return [start,end];
    },
    "YESTERDAY": ()=>{
        var start = moment().subtract(1, 'days').startOf('day').valueOf();
        var end = moment().subtract(1, 'days').endOf('day').valueOf();
        return [start,end];
    },
    "Today": ()=>{
        var start = moment().startOf('day').valueOf();
        var end = moment().endOf('day').valueOf();
        return [start,end];
    },
    "Yesterday": ()=>{
        var start = moment().subtract(1, 'days').startOf('day').valueOf();
        var end = moment().subtract(1, 'days').endOf('day').valueOf();
        return [start,end];
    },
    "Last 7 Days":()=>{
        var start = moment().subtract(6, 'days').startOf('day').valueOf();
        var end = moment().endOf('day').valueOf();
        return [start,end];
    },
    "Last 30 Days": ()=>{
        var start = moment().subtract(29, 'days').startOf('day').valueOf();
        var end = moment().endOf('day').valueOf();
        return [start,end];
    },
    "This Month":()=>{
        var start = moment().startOf('month').valueOf();
        var end = moment().endOf('month').valueOf();
        return [start,end];
    },
    "Last Month":()=>{
        var start = moment().subtract(1, 'month').startOf('month').valueOf();
        var end = moment().subtract(1, 'month').endOf('month').valueOf();
        return [start,end]; 
    },
    "Last 90 Days":()=>{
        var start = moment().subtract(89, 'days').valueOf();
        var end = moment().valueOf();
        return [start,end];
    },
}

export const DateConfig = {
    "YESTERDAY":  moment().day(-1).toDate()
}